// extracted by mini-css-extract-plugin
module.exports = {"fileView":"FileView_fileView__2m4zB","fileSize":"FileView_fileSize__308C6","fileName":"FileView_fileName__fClbM"};